import React, { Component } from "react";
import "../resources/global.css";
import "../resources/loginRegister.css";
import "../resources/login.css";
import Logo from "./commons/Logo";
import Form from "./commons/form";
import Joi from "joi-browser";
import userService from "../services/userService";
import { withRouter } from "react-router-dom";

class Login extends Form {
  state = {
    data: {
      username: "",
      password: "",
    },
    errors: {},
    loading: false,
  };

  componentDidMount() {
    const currentUser = userService.getCurrentUser();
    if (currentUser != null) {
      this.props.history.push("/");
    }
  }

  customUsernameErrors = {
    "any.empty": "Don't forget a username!",
  };

  customPasswordErrors = {
    "any.empty": "Don't forget a password!",
    "string.min": "Password must be at least 6 characters",
    "string.max": "Password must be less than 40 characters",
  };

  schema = {
    username: Joi.string()
      .max(50)
      .required()
      .label("Username")
      .error((errors) => {
        errors.forEach((err) => {
          err.message = this.customUsernameErrors[err.type];
        });
        return errors;
      }),
    password: Joi.string()
      .max(40)
      .required()
      .label("Password")
      .error((errors) => {
        errors.forEach((err) => {
          err.message = this.customPasswordErrors[err.type];
        });
        return errors;
      }),
  };

  startLoading = () => {
    this.setState({
      loading: true,
    });
  };

  finishLoading = () => {
    this.setState({
      loading: false,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = this.state.data;
    this.startLoading();
    try {
      const response = await userService.authenticate(username, password);
      const token = response.data.token;
      this.finishLoading();
      userService.storeJwt(token);
      window.location = "/";
    } catch (error) {
      this.finishLoading();
      if (error.response && error.response.status === 401) {
        const errors = { ...this.state.errors };
        errors["password"] = "Incorrect username and/or password";
        this.setState({ errors });
      }
    }
  };

  render() {
    return (
      <div id="container">
        <div id="form-container">
          <Logo />
          <form autoComplete="off" onSubmit={this.handleSubmit}>
            <h2 className="heading">Welcome back!</h2>
            <div style={{ marginBottom: 10 }} className="input-container">
              {this.renderInput("username", "Username")}
            </div>
            <div className="input-container">
              {this.renderInput("password", "Password", "password")}
            </div>
            <div className="footer">
              {this.renderButton("Let's go!", this.state.loading)}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);
